import { render, staticRenderFns } from "./RolePermissionsList.vue?vue&type=template&id=66b9d664"
import script from "./RolePermissionsList.vue?vue&type=script&lang=js"
export * from "./RolePermissionsList.vue?vue&type=script&lang=js"
import style0 from "./RolePermissionsList.vue?vue&type=style&index=0&id=66b9d664&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports